import { DynamicFormRenderer } from '@scientist/dynamic-form-renderer';
import { SimpleWysiwygRichText } from '@scientist/dynamic-form-renderer/richtext-simple';
import { DownshiftMultiSelect } from '@scientist/dynamic-form-renderer/enhanced-select';
import ChemDoodleWidget from '../widgets/ChemDoodleWidget.jsx';

const widgetComponents = { chem_doodle: ChemDoodleWidget };

// Thin mountable wrapper so DynamicFormRenderer can be used outside the builder
// (e.g. the dynamic form show page's side-by-side comparison). The renderer is
// uncontrolled — it seeds once from `definition`/`defaultValue` on mount.
//
// `mode` defaults to "preview" (interactive) to mirror the legacy Alpaca form,
// which has no true read-only mode. Pass mode="readonly" for display-only.
//
// The rich text adapter is always wired so textarea fields with
// `config.rich_text` render an editor. `enableRichText` mirrors the legacy
// render-site `enable_rich_text` flag (upgrades ALL textareas) for call sites
// migrating off Alpaca.
export default function DynamicFormPreview({ definition, defaultValue, mode = 'preview', enableRichText = false }) {
  return (
    <DynamicFormRenderer
      definition={definition}
      defaultValue={defaultValue}
      mode={mode}
      validateOnMount
      enableRichText={enableRichText}
      richTextAdapter={SimpleWysiwygRichText}
      enhancedSelectAdapter={DownshiftMultiSelect}
      widgetComponents={widgetComponents}
    />
  );
}
